import clsx from 'clsx';
import _ from 'lodash';
import { Field, useForm } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import SelectUnit from '@/core/SelectUnit.molecule';
import { FormFieldWrapper } from '@/formbuilder/FormFieldWrapper';
import {
  getFormFieldProps,
  getFormFieldWrapperProps,
  getValidationFunction,
} from '@/formbuilder/formbuilder.utilities';
import { Icon } from '@seeqdev/qomponents';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';

export interface SelectUnitIF extends ValidatingFormComponent<string> {
  component: 'SelectUnitFormComponent';
  disabled?: boolean;
  label?: string;
  placeholder?: string;
  units?: Record<string, string[]>;
}

export const SelectUnitFormComponent = (props: SelectUnitIF) => {
  const {
    name,
    validation,
    extendValidation,
    disabled,
    extraClassNames,
    label,
    tooltip,
    placeholder,
    required = true,
    wrapperClassNames,
    units,
  } = props;
  const { t } = useTranslation();

  const defaultValidation = (value?: string) => required && _.isEmpty(value);
  const formState = useForm().getState();

  const showError =
    _.has(formState.errors, name) &&
    (_.has(formState.dirtyFields, name) || _.has(formState.dirtyFieldsSinceLastSubmit, name)) &&
    formState.hasValidationErrors;

  return (
    <FormFieldWrapper
      {...getFormFieldWrapperProps(props, ['id', 'label', 'tooltip'])}
      wrapperClassNames={clsx('flexFill', wrapperClassNames)}>
      <Field name={name} validate={getValidationFunction(defaultValidation, extendValidation, validation)}>
        {({ input, meta }) => (
          <div className={extraClassNames}>
            {label && (
              <div className="mb5">
                {t(label)}
                {tooltip && <Icon icon="fa-question-circle" large={true} tooltip={t(tooltip)} extraClassNames="pl5" />}
              </div>
            )}
            <SelectUnit
              placeholder={placeholder ? t(placeholder) : undefined}
              extraClassNames={extraClassNames}
              {...getFormFieldProps(formState, input, meta, props)}
              isDisabled={disabled}
              menuPortalTarget={document.body}
              showError={showError}
              units={units}
            />
          </div>
        )}
      </Field>
    </FormFieldWrapper>
  );
};
